export default __webpack_public_path__ + "src/assets/icn-question-white.945c8443c77932698f6a0cc28d6cffcc.svg";